
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiForwardStopped as ObiForwardStoppedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-forward-stopped.js';
 
 
 

 
 export const ObiForwardStopped = createComponent({
   react: React,
   tagName: 'obi-forward-stopped',
   elementClass: ObiForwardStoppedElement,
   events: {
     
   }
  });
 
 